export type FlowType = APICustomFieldGroup['object_type']

export const createDefaults = <T>(val: T): Record<FlowType, T> => {
  return {
    'external-user': val,
    task: val,
    user: val
  }
}

export const formatData = (data: APIFlow & Record<string, any>) => {
  const { id, object_type, title, description, archived_at, fields = [] } = data

  const formatted: APIFlow = {
    id,
    object_type,
    title,
    description,
    archived_at,
    fields
  }

  return formatted
}
